import { DealBean, DealControllerApi, ItemResponseDealBeanObject, ListResponseDealBean } from 'src/api/api';
import { BaseApi, configuration } from '../../../api/BaseApi';
import { processError } from '../../../api/customFetch';

class DealApi extends BaseApi {
    api: DealControllerApi;

    constructor() {
        super();
        this.api = new DealControllerApi(configuration, configuration.basePath, this.customFetch);
    }

  list(size: number = 20, page: number = 1, search?: string, isDealId?: boolean): Promise<ListResponseDealBean> {
    return this.api.dealList(search, {query: {size, page, isDealId}}).then(list => {
        return Promise.resolve(list);
    }).catch(err => {
        return processError(err);
    });
}

   async getAllDealTypes(): Promise<ListResponseDealBean> {
        return this.api.dealTypesList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    async getAllDealStatus(): Promise<ListResponseDealBean> {
         return this.api.dealStatusList().then(list => {
             return Promise.resolve(list);
         }).catch(err => {
             return processError(err);
         });
     }

      async getAllDeviceTypes(): Promise<ListResponseDealBean> {
         return this.api.deviceTypeList().then(list => {
             return Promise.resolve(list);
         }).catch(err => {
             return processError(err);
         });
     }  
        async getAllMediaTypes(): Promise<ListResponseDealBean> {
         return this.api.mediaTypeList().then(list => {
             return Promise.resolve(list);
         }).catch(err => {
             return processError(err);
         });
     }  
        async getAllAdSizes(): Promise<ListResponseDealBean> {
         return this.api.adSizesList().then(list => {
             return Promise.resolve(list);
         }).catch(err => {
             return processError(err);
         });
     }  
    
    all(): Promise<ListResponseDealBean> {
        return this.api.dealList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    create(deal: DealBean): Promise<ItemResponseDealBeanObject> {
        return this.api.createDeal(deal).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, deal: DealBean): Promise<ItemResponseDealBeanObject> {
        return this.api.editDeal(deal, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id: number): Promise<ItemResponseDealBeanObject> {
        return this.api.deal(id).then(deal => {
            return Promise.resolve(deal);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteDeal(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }
}

const dealApi = new DealApi();

export default dealApi;
